import { MatchForecast, valueof } from './MatchForecast';
import {
  decimalToAmerican,
  decimalToFractional,
} from '../../shared/InputOdds/OddUtils';
import { Mediafile } from '../Media';
import { Bookie, FormattedOdds, PriceType, Stake } from '../utils';
import { Channel, Tip, TipType } from './Tip';
import { Validations } from './Validations';

export class CombinedTip implements Tip {
  type: TipType = 'COMBINED';
  channel: Channel;
  analysis: string;
  rawAnalysis: string;
  media: Mediafile[];
  matchForecasts: MatchForecast[];
  accumulatedOdds: FormattedOdds;
  stake: number;
  bookie: Bookie;
  betImage: Mediafile | null;
  priceType: PriceType;
  pricingTierCode: string;
  validations: Validations;
  discountPercentage: number = 0;

  constructor(
    matchForecasts: MatchForecast[],
    bookie: Bookie,
    stake: Stake,
    channel: Channel,
  ) {
    this.matchForecasts = matchForecasts;
    this.accumulatedOdds = this.getAccumulatedOdds(matchForecasts);
    this.stake = 0;
    this.bookie = bookie;
    this.analysis = '';
    this.rawAnalysis = '';
    this.media = [];
    this.betImage = null;
    this.priceType = channel.type === 'PREMIUM' ? 'PREMIUM' : 'FREE';
    this.pricingTierCode = '';
    this.validations = new Validations(matchForecasts);
    this.channel = channel;
  }

  private getAccumulatedOdds(matchForecasts: MatchForecast[]): FormattedOdds {
    let totalOdds = 1;
    let hasOdds = false;
    matchForecasts.forEach((match_forecast: MatchForecast) => {
      if (!!match_forecast.formatted_odds.decimal) {
        hasOdds = true;
        totalOdds *= parseFloat(
          parseFloat(match_forecast.formatted_odds.decimal).toFixed(3),
        );
      }
    });

    return {
      american: hasOdds ? decimalToAmerican(totalOdds) : '',
      decimal: hasOdds ? totalOdds.toFixed(2).toString() : '',
      fractional: hasOdds ? decimalToFractional(totalOdds, true) : '',
    };
  }

  public setValue(key: keyof CombinedTip, value: valueof<CombinedTip>) {
    this.setAttribute<CombinedTip, keyof CombinedTip>(this, key, value);
  }
  private setAttribute<T extends Object, U extends keyof T>(
    obj: T,
    key: U,
    value: T[U],
  ) {
    obj[key] = value;
  }

  public setMatchForecast(matchForecast: MatchForecast): void {
    this.matchForecasts[matchForecast.index] = matchForecast;
  }

  public setAccumulatedOdds(
    matchForecast: MatchForecast,
    odds: FormattedOdds,
  ): void {
    this.matchForecasts[matchForecast.index].formatted_odds = odds;
    this.accumulatedOdds = this.getAccumulatedOdds(this.matchForecasts);
  }
  public recalculateAccumulatedOdds(): void {
    this.accumulatedOdds = this.getAccumulatedOdds(this.matchForecasts);
  }
  public addMatchForecast(matchForecast: MatchForecast): void {
    this.matchForecasts.push(matchForecast);
  }
  public checkStepValidity(stepNumber: number): boolean {
    return this.validations.checkStepValidity(stepNumber);
  }
  public deleteMatchForecast(indexToDelete: number): void {
    const newArr = [
      ...this.matchForecasts.slice(0, indexToDelete),
      ...this.matchForecasts.slice(indexToDelete + 1),
    ];

    for (let i = indexToDelete; i < newArr.length; i++) {
      newArr[i]['index'] = i;
    }
    this.matchForecasts = newArr;
  }
  public runValidations() {
    this.validations.runValidations(this);
  }
}
